import type { JSX } from 'react';
import classNames from 'classnames';
import { Group } from '@mantine/core';
import type { ICardActionsProps } from './types';
import classes from './Card.module.css';

function CardActions({ children, className }: Readonly<ICardActionsProps>): JSX.Element {
  return (
    <Group gap="xs" justify="space-between" className={classNames(classes.actions, className)}>
      {children}
    </Group>
  );
}

export default CardActions;
